import { render, staticRenderFns } from "./TicketMedioSupervisorTime4.vue?vue&type=template&id=4e79c94b&scoped=true&"
import script from "./TicketMedioSupervisorTime4.vue?vue&type=script&lang=js&"
export * from "./TicketMedioSupervisorTime4.vue?vue&type=script&lang=js&"
import style0 from "./TicketMedioSupervisorTime4.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./TicketMedioSupervisorTime4.vue?vue&type=style&index=1&id=4e79c94b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e79c94b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VRow})
